import { HelpMessage } from 'utils/constants'
import LabTechSelectProvider from 'components/CIMSSelect/common/LabTechSelect/LabTechSelectContext'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import TestingLabSelectProvider from 'components/CIMSSelect/common/TestingLabSelect/TestingLabSelectContext'
import CIMSTable from 'components/CIMSTable'
import { WithPayItemGlobalId } from 'components/CIMSTable/components/HeaderActionButtons/types'
import ConcreteTestSetTrackerProvider, {
  useConcreteTestSetTrackerContext,
} from './ConcreteTestSetTrackerContext'
import BreakDataModal from './components/BreakDataModal'
import PDFModal from './components/PDFModal'
import UploadModal from './components/UploadModal'
import { useColumns } from './hooks/useColumns'
import { useCustom } from './hooks/useCustom'
import { useExpand } from './hooks/useExpand'
import { usePayItems } from './hooks/usePayItems'

const ConcreteTestSetTrackerTable: React.FC = () => {
  const {
    concreteTestSets,
    refetch: onReload,
    testSets,
    pdfModal,
    uploadModal,
    breakDataModal,
  } = useConcreteTestSetTrackerContext()

  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Actions
  return (
    <CIMSTable
      columns={useColumns()}
      rowKey="globalId"
      records={concreteTestSets}
      actions={{
        header: { onReload, deepLinkKey: 'globalId', payItems: usePayItems() },
        row: { help, custom: useCustom() },
      }}
      loading={testSets.loading}
      expand={useExpand()}
    >
      <UploadModal
        visible={uploadModal.visible}
        onClose={() => uploadModal.toggle(null)}
        state={uploadModal.state}
      />
      <PDFModal
        visible={pdfModal.visible}
        onClose={() => pdfModal.toggle(null)}
        state={pdfModal.state}
      />
      <BreakDataModal
        visible={breakDataModal.visible}
        onClose={() => breakDataModal.toggle(null)}
        state={breakDataModal.state}
      />
    </CIMSTable>
  )
}

const ConcreteTestSetTracker: React.FC<WithPayItemGlobalId> = ({
  payItemGlobalId,
}) => {
  return (
    <PayItemSelectProvider>
      <LabTechSelectProvider>
        <TestingLabSelectProvider>
          <ConcreteTestSetTrackerProvider payItemGlobalId={payItemGlobalId}>
            <ConcreteTestSetTrackerTable />
          </ConcreteTestSetTrackerProvider>
        </TestingLabSelectProvider>
      </LabTechSelectProvider>
    </PayItemSelectProvider>
  )
}

export default ConcreteTestSetTracker
